const BACKEND_API_URL =
  import.meta.env.VITE_BACKEND_API_URL ||
  import.meta.env.VITE_API_URL ||
  'http://localhost:3001/api/v1';

export interface CouponLineInput {
  sku: string;
  site_id: number;
  price_cents: number;
}

export interface CouponLineResult {
  sku: string;
  site_id: number;
  original_cents: number;
  discount_cents: number;
  final_cents: number;
  eligible: boolean;
}

export interface ValidateCouponResult {
  ok: boolean;
  reason?: string;
  message?: string;
  benefit_type?: 'item' | 'shipping';
  code?: string;
  coupon_id?: number;
  discount_cents?: number;
  eligible_subtotal_cents?: number;
  lines?: CouponLineResult[];
  scope_note?: string;
  shipping_discount_cents?: number;
  shipping_final_cents?: number;
}

export interface ShippingEvaluateResult {
  ok?: boolean;
  shipping_discount_cents: number;
  shipping_final_cents: number;
  rule_id?: number | null;
  rule_name?: string | null;
  message?: string | null;
}

export async function validateCoupon(input: {
  code: string;
  email: string;
  customer_id?: number | null;
  shipping_method?: string;
  shipping_cents?: number;
  lines: CouponLineInput[];
}): Promise<ValidateCouponResult> {
  const res = await fetch(`${BACKEND_API_URL}/coupons/validate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  return res.json();
}

export async function evaluateShipping(input: {
  shipping_method: string;
  shipping_cents: number;
  lines: CouponLineInput[];
}): Promise<ShippingEvaluateResult> {
  const res = await fetch(`${BACKEND_API_URL}/shipping/evaluate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  if (!res.ok) {
    return {
      shipping_discount_cents: 0,
      shipping_final_cents: input.shipping_cents,
      message: null,
    };
  }
  return res.json();
}
